
export function objectExtend(a, b) {

  // Don't touch 'null' or 'undefined' objects.
  if (a == null || b == null) {
    return a;
  }

  Object.keys(b).forEach(function (key) {
    if (Object.prototype.toString.call(b[key]) == '[object Object]') {
      if (Object.prototype.toString.call(a[key]) != '[object Object]') {
        a[key] = b[key];
      } else {
        a[key] = objectExtend(a[key], b[key]);
      }
    } else {
      a[key] = b[key];
    }
  });

  return a;
};

/**
 * Auth Plugin
 *
 * (see https://vuejs.org/v2/guide/plugins.html for more info on Vue.js plugins)
 *
 * Handles login and token authentication using FireBase.
 */
export default {
  options: {
    tokenHeader: 'Authorization',
    tokenType: 'Bearer',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    uidName: 'uidAdmin',
    isAdmin: 'isAdmin',
    isModerator: 'isModerator',
    isCoursesAdmin: 'isCoursesAdmin'
  },
  router: null,
  storage: null,
  http: null,
  store: null,

  install (Vue, options) {
    var $auth = this
    $auth.vue = Vue;
    $auth.storage = Vue.prototype.$localStorage
    $auth.http = Vue.prototype.$http
    $auth.options = objectExtend(this.options, options)

    $auth.bindRequestInterceptor()
    $auth.bindResponseInterceptor()
    Object.defineProperties(Vue.prototype, {
      $auth: {
        get: function () {
          return $auth
        }
      },
    })
  },

  /**
   * Login user using email and password
   * @param  {Object} user           User data
   * @param  {Object} requestOptions Request options
   * @return {Promise}               Request promise
   */
  login (user, requestOptions) {
    var $auth = this
    const promise = $auth.http.post($auth.vue.mcf.api.auth.login, {
      email: user.email,
      password: user.password
    }).then(function (response) {
      $auth.setAccessToken(response.data.data.token)
      $auth.setRefreshToken(response.data.data.refresh_token)
      return $auth.http.get($auth.vue.mcf.api.user.getCurrentUser).then(res => {
        return res.data;
      })
    }, error => {
    }).catch(function(error) {
      console.log('error', error);
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
    });

    return promise
  },

  /**
   * Logout current user
   * @param  {Object} requestOptions  Logout request options object
   * @return {Promise}                Request promise
   */
  logout (requestOptions) {
    this.removeToken()
  },

  isAuthenticated () {
    return !!this.getAccessToken();
  },

  isAuthenticatedAsCoursesAdmin () {
    return this.storage.get(this.options.isCoursesAdmin);
  },

  isAuthenticatedAsAdmin () {
    return this.storage.get(this.options.isAdmin);
  },

  isAuthenticatedAsModerator () {
    return this.storage.get(this.options.isModerator);
  },

  /**
   * Get token if user is authenticated
   * @return {String} Authentication token
   */
  getAccessToken () {
    return this.storage.get(this.options.accessToken);
  },

  getRefreshToken () {
    return this.storage.get(this.options.refreshToken);
  },

  /**
   * Set new authentication token
   * @param accessToken
   */
  setAccessToken (accessToken) {
    this.storage.set(this.options.accessToken, accessToken)
  },

  setRefreshToken (refreshToken) {
    this.storage.set(this.options.refreshToken, refreshToken)
  },

  /**
   * Remove authentication token
   * @param {String|Object} token
   */
  removeToken () {
    this.storage.remove(this.options.accessToken);
    this.storage.remove(this.options.refreshToken);
    this.storage.remove(this.options.uidName);
    this.storage.remove(this.options.isAdmin);
    this.storage.remove('current_course_id');
    this.storage.remove(this.options.isModerator);
    this.storage.remove(this.options.isCoursesAdmin);
  },

  bindRequestInterceptor () {
    var $auth = this

    $auth.http.interceptors.request.use((config) => {
      const accessToken = this.getAccessToken();
      if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }
      return Promise.resolve(config);
      })
  },

  bindResponseInterceptor () {
    var $auth = this
    $auth.http.interceptors.response.use(response => {
      return response
    }, error => {
      const originalRequest = error.config
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if (originalRequest.url.includes('refresh_token')) {
          window.location.href = '/';
          return $auth.logout();
        }
        return $auth.http.post($auth.vue.mcf.api.auth.refreshToken, {
          refresh_token: this.getRefreshToken()
        }).then(res => {
          this.setAccessToken(res.data.data.token)
          this.setRefreshToken(res.data.data.refresh_token)
          $auth.http.defaults.headers.common['Authorization'] = `Bearer ${res.data.data.token}`;
          return $auth.http(originalRequest)
        })
      }
      return Promise.reject(error)
    })
  },

}
